module.exports = __webpack_public_path__ + "static/media/eventTicket.927613cb.svg";